<div *ngIf="reportType == 'CreditMonthwise'">
  <div class="table-wrapper">
    <div class="container" id="print-section">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th colspan="2">Vivek Saptahik</th>
            <th colspan="4">Advt. Credit Note Register</th>
            <th colspan="1">Monthwise</th>
          </tr>
          <tr>
            <th colspan="4"></th>
            <th colspan="3" style="font-size: medium;">Date From : {{ startDate | date: 'dd-MM-yyyy' }} To : {{ endDate
              | date: 'dd-MM-yyyy' }}</th>
          </tr>
          <tr>
            <th colspan="3">Month</th>
            <th style="text-align: center;" colspan="4">Credit Note Amount</th>
          </tr>
          <tr>
            <th colspan="4"></th>
            <th style="text-align: center;">TDS</th>
            <th style="text-align: center;">Other</th>
            <th style="text-align: center;">Total Amount</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of CreditNoteMFormBeans; let i = index">
            <td style="text-align: left; font-weight: bold;font-size: 16px;" colspan="4">{{ data.month }} - {{ data.year
              }}</td>
            <td colspan="1" style="text-align: end;font-weight: bold;font-size: 16px;">{{ data.tds_amt }}</td>
            <td colspan="1" style="text-align: end;font-weight: bold;font-size: 16px;">{{ data.other_credit_amt }}</td>
            <td colspan="1" style="text-align: end;font-weight: bold;font-size: 16px;">{{ data.total_amt }}</td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="4" style="text-align: end; font-weight: bold;">Total:</td>

            <td style="text-align: end; font-weight: bold;font-size: medium;">
              {{ CreditadvtOffMTDS.toFixed(2) }}
            </td>

            <td style="text-align: end; font-weight: bold;font-size: medium;">
              {{ CreditadvtOffMOther.toFixed(2) }}
            </td>

            <td style="text-align: end; font-weight: bold;font-size: medium;">
              {{ CreditadvtOffMTotal.toFixed(2) }}
            </td>
          </tr>
        </tfoot>

      </table>
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
      <button class="noPrint" style="margin-top: 2%; margin-right: 2%;"
        (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
        Export
      </button>

      <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
        printSectionId="print-section" ngxPrint>
        Print
      </button>

      <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
        Close
      </button>
    </div>
  </div>
</div>